const psg = [
  {
    id: 1,
    pais: "europa",
    liga: "ligue-1",
    time: "paris-saint-germain",
    nome: "Paris Saint Germain 25/26 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "psg",
      "paris saint germain 2025",
      "paris",
      "saint germain",
      "2025 paris saint germain",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/psg/25-26-01/uni0.png",
      "/images/europa/psg/25-26-01/uni1.png",
      "/images/europa/psg/25-26-01/uni2.png",
      "/images/europa/psg/25-26-01/uni3.png",
      "/images/europa/psg/25-26-01/uni4.png",
    ],
  },
  {
    id: 2,
    pais: "europa",
    liga: "ligue-1",
    time: "paris-saint-germain",
    nome: "Paris Saint Germain 25/26 - Uniforme 3",
    tipo: "masculino",
    aliases: [
      "psg",
      "paris saint germain 2025",
      "paris",
      "saint germain",
      "2025 paris saint germain",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/psg/25-26-03/uni0.png",
      "/images/europa/psg/25-26-03/uni1.png",
      "/images/europa/psg/25-26-03/uni2.png",
      "/images/europa/psg/25-26-03/uni3.png",
      "/images/europa/psg/25-26-03/uni4.png",
    ],
  },
  {
    id: 3,
    pais: "europa",
    liga: "ligue-1",
    time: "paris-saint-germain",
    nome: "Paris Saint Germain 25/26 - Uniforme de Pré Jogo (Azul)",
    tipo: "masculino",
    aliases: [
      "psg",
      "paris saint germain 2025",
      "paris",
      "saint germain",
      "2025 paris saint germain",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/psg/25-26-05-pja/uni0.png",
      "/images/europa/psg/25-26-05-pja/uni1.png",
      "/images/europa/psg/25-26-05-pja/uni2.png",
      "/images/europa/psg/25-26-05-pja/uni3.png",
      "/images/europa/psg/25-26-05-pja/uni4.png",
    ],
  },
  {
    id: 4,
    pais: "europa",
    liga: "ligue-1",
    time: "paris-saint-germain",
    nome: "Paris Saint Germain 25/26 - Uniforme de Treino (Preta)",
    tipo: "masculino",
    aliases: [
      "psg",
      "paris saint germain 2025",
      "paris",
      "saint germain",
      "2025 paris saint germain",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/psg/25-26-05-tp/uni0.png",
      "/images/europa/psg/25-26-05-tp/uni1.png",
      "/images/europa/psg/25-26-05-tp/uni2.png",
      "/images/europa/psg/25-26-05-tp/uni3.png",
      "/images/europa/psg/25-26-05-tp/uni4.png",
    ],
  },
  {
    id: 5,
    pais: "europa",
    liga: "ligue-1",
    time: "paris-saint-germain",
    nome: "Paris Saint Germain 25/26 - Uniforme Edição Especial",
    tipo: "masculino",
    aliases: [
      "psg",
      "paris saint germain 2025",
      "paris",
      "saint germain",
      "2025 paris saint germain",
      "2025",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/psg/25-26-00-es/uni0.jpeg",
      "/images/europa/psg/25-26-00-es/uni1.jpeg",
      "/images/europa/psg/25-26-00-es/uni2.jpeg",
      "/images/europa/psg/25-26-00-es/uni3.jpeg",
      "/images/europa/psg/25-26-00-es/uni4.jpeg",
    ],
  },
  {
    id: 6,
    pais: "europa",
    liga: "ligue-1",
    time: "paris-saint-germain",
    nome: "Paris Saint Germain 24/25 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "psg",
      "paris saint germain 2024",
      "paris",
      "saint germain",
      "2024 paris saint germain",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/psg/24-25-01/uni0.jpg",
      "/images/europa/psg/24-25-01/uni1.jpg",
    ],
  },
  {
    id: 7,
    pais: "europa",
    liga: "ligue-1",
    time: "paris-saint-germain",
    nome: "Paris Saint Germain 24/25 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "psg",
      "paris saint germain 2024",
      "paris",
      "saint germain",
      "2024 paris saint germain",
      "2024",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/psg/24-25-02/uni0.jpeg",
      "/images/europa/psg/24-25-02/uni1.jpeg",
      "/images/europa/psg/24-25-02/uni2.jpeg",
      "/images/europa/psg/24-25-02/uni3.jpeg",
      "/images/europa/psg/24-25-02/uni4.jpeg",
    ],
  },
  {
    id: 8,
    pais: "europa",
    liga: "ligue-1",
    time: "paris-saint-germain",
    nome: "Paris Saint Germain 23/24 - Uniforme 4",
    tipo: "masculino",
    aliases: [
      "psg",
      "paris saint germain 2023",
      "paris",
      "saint germain",
      "2023 paris saint germain",
      "2023",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/psg/23-24-04/uni0.jpg",
      "/images/europa/psg/23-24-04/uni1.jpg",
      "/images/europa/psg/23-24-04/uni2.jpg",
      "/images/europa/psg/23-24-04/uni3.jpg",
      "/images/europa/psg/23-24-04/uni4.jpg",
    ],
  },
  {
    id: 9,
    pais: "europa",
    liga: "ligue-1",
    time: "paris-saint-germain",
    nome: "Paris Saint Germain 22/23 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "psg",
      "paris saint germain 2022",
      "paris",
      "saint germain",
      "2022 paris saint germain",
      "2022",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/psg/22-23-02/uni0.jpg",
      "/images/europa/psg/22-23-02/uni1.jpg",
      "/images/europa/psg/22-23-02/uni2.jpg",
      "/images/europa/psg/22-23-02/uni3.jpg",
      "/images/europa/psg/22-23-02/uni4.jpg",
    ],
  },
  {
    id: 10,
    pais: "europa",
    liga: "ligue-1",
    time: "paris-saint-germain",
    nome: "Paris Saint Germain 22/23 - Uniforme de Pré Jogo",
    tipo: "masculino",
    aliases: [
      "psg",
      "paris saint germain 2022",
      "paris",
      "saint germain",
      "2022 paris saint germain",
      "2022",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/psg/22-23-05-pj/uni0.jpg",
      "/images/europa/psg/22-23-05-pj/uni1.jpg",
      "/images/europa/psg/22-23-05-pj/uni2.jpg",
      "/images/europa/psg/22-23-05-pj/uni3.jpg",
      "/images/europa/psg/22-23-05-pj/uni4.jpg",
    ],
  },
  {
    id: 11,
    pais: "europa",
    liga: "ligue-1",
    time: "paris-saint-germain",
    nome: "Paris Saint Germain 22/23 - Uniforme de Treino (Preta)",
    tipo: "masculino",
    aliases: [
      "psg",
      "paris saint germain 2022",
      "paris",
      "saint germain",
      "2022 paris saint germain",
      "2022",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/psg/22-23-05-tp/uni0.jpg",
      "/images/europa/psg/22-23-05-tp/uni1.jpg",
      "/images/europa/psg/22-23-05-tp/uni2.jpg",
      "/images/europa/psg/22-23-05-tp/uni3.jpg",
      "/images/europa/psg/22-23-05-tp/uni4.jpg",
    ],
  },
  {
    id: 11,
    pais: "europa",
    liga: "ligue-1",
    time: "paris-saint-germain",
    nome: "Paris Saint Germain 21/22 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "psg",
      "paris saint germain 2021",
      "paris",
      "saint germain",
      "2021 paris saint germain",
      "2021",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/psg/21-22-01/uni0.jpg",
      "/images/europa/psg/21-22-01/uni1.jpg",
      "/images/europa/psg/21-22-01/uni2.jpg",
      "/images/europa/psg/21-22-01/uni3.jpg",
      "/images/europa/psg/21-22-01/uni4.jpg",
    ],
  },
  {
    id: 12,
    pais: "europa",
    liga: "ligue-1",
    time: "paris-saint-germain",
    nome: "Paris Saint Germain 21/22 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "psg",
      "paris saint germain 2021",
      "paris",
      "saint germain",
      "2021 paris saint germain",
      "2021",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/psg/21-22-02/uni0.jpg",
      "/images/europa/psg/21-22-02/uni1.jpg",
      "/images/europa/psg/21-22-02/uni2.jpg",
      "/images/europa/psg/21-22-02/uni3.jpg",
      "/images/europa/psg/21-22-02/uni4.jpg",
    ],
  },
  {
    id: 13,
    pais: "europa",
    liga: "ligue-1",
    time: "paris-saint-germain",
    nome: "Paris Saint Germain 21/22 - Uniforme 3",
    tipo: "masculino",
    aliases: [
      "psg",
      "paris saint germain 2021",
      "paris",
      "saint germain",
      "2021 paris saint germain",
      "2021",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/psg/21-22-03/uni0.jpg",
      "/images/europa/psg/21-22-03/uni1.jpg",
      "/images/europa/psg/21-22-03/uni2.jpg",
      "/images/europa/psg/21-22-03/uni3.png",
      "/images/europa/psg/21-22-03/uni4.png",
    ],
  },
  {
    id: 14,
    pais: "europa",
    liga: "ligue-1",
    time: "paris-saint-germain",
    nome: "Paris Saint Germain 21/22 - Uniforme de Pré Jogo",
    tipo: "masculino",
    aliases: [
      "psg",
      "paris saint germain 2021",
      "paris",
      "saint germain",
      "2021 paris saint germain",
      "2021",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/psg/21-22-05-pjt/uni0.jpg",
      "/images/europa/psg/21-22-05-pjt/uni1.jpg",
      "/images/europa/psg/21-22-05-pjt/uni2.jpg",
      "/images/europa/psg/21-22-05-pjt/uni3.jpg",
      "/images/europa/psg/21-22-05-pjt/uni4.jpg",
    ],
  },
  {
    id: 15,
    pais: "europa",
    liga: "ligue-1",
    time: "paris-saint-germain",
    nome: "Paris Saint Germain 21/22 - Uniforme de Trein (Branca)",
    tipo: "masculino",
    aliases: [
      "psg",
      "paris saint germain 2021",
      "paris",
      "saint germain",
      "2021 paris saint germain",
      "2021",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/psg/21-22-05-tb/uni0.jpg",
      "/images/europa/psg/21-22-05-tb/uni1.jpg",
      "/images/europa/psg/21-22-05-tb/uni2.jpg",
      "/images/europa/psg/21-22-05-tb/uni3.jpg",
      "/images/europa/psg/21-22-05-tb/uni4.jpg",
    ],
  },
  {
    id: 16,
    pais: "europa",
    liga: "ligue-1",
    time: "paris-saint-germain",
    nome: "Paris Saint Germain 20/21 - Uniforme 3",
    tipo: "masculino",
    aliases: [
      "psg",
      "paris saint germain 2020",
      "paris",
      "saint germain",
      "2020 paris saint germain",
      "2020",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/psg/20-21-03/uni0.jpg",
      "/images/europa/psg/20-21-03/uni1.jpg",
      "/images/europa/psg/20-21-03/uni2.jpg",
      "/images/europa/psg/20-21-03/uni3.jpg",
      "/images/europa/psg/20-21-03/uni4.jpg",
    ],
  },
  {
    id: 17,
    pais: "europa",
    liga: "ligue-1",
    time: "paris-saint-germain",
    nome: "Paris Saint Germain 20/21 - Uniforme 4",
    tipo: "masculino",
    aliases: [
      "psg",
      "paris saint germain 2020",
      "paris",
      "saint germain",
      "2020 paris saint germain",
      "2020",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/psg/20-21-04/uni0.jpg",
      "/images/europa/psg/20-21-04/uni1.jpg",
      "/images/europa/psg/20-21-04/uni2.jpg",
      "/images/europa/psg/20-21-04/uni3.jpg",
      "/images/europa/psg/20-21-04/uni4.jpg",
    ],
  },
  {
    id: 18,
    pais: "europa",
    liga: "ligue-1",
    time: "paris-saint-germain",
    nome: "Paris Saint Germain 19/20 - Uniforme 1",
    tipo: "masculino",
    aliases: [
      "psg",
      "paris saint germain 2019",
      "paris",
      "saint germain",
      "2019 paris saint germain",
      "2019",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/psg/19-20-01/uni0.jpg",
      "/images/europa/psg/19-20-01/uni1.jpg",
      "/images/europa/psg/19-20-01/uni2.jpg",
      "/images/europa/psg/19-20-01/uni3.jpg",
      "/images/europa/psg/19-20-01/uni4.jpg",
    ],
  },
  {
    id: 19,
    pais: "europa",
    liga: "ligue-1",
    time: "paris-saint-germain",
    nome: "Paris Saint Germain 19/20 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "psg",
      "paris saint germain 2019",
      "paris",
      "saint germain",
      "2019 paris saint germain",
      "2019",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/psg/19-20-02/uni0.jpg",
      "/images/europa/psg/19-20-02/uni1.jpg",
      "/images/europa/psg/19-20-02/uni2.jpg",
      "/images/europa/psg/19-20-02/uni3.jpg",
      "/images/europa/psg/19-20-02/uni4.jpg",
    ],
  },
  {
    id: 20,
    pais: "europa",
    liga: "ligue-1",
    time: "paris-saint-germain",
    nome: "Paris Saint Germain 19/20 - Uniforme 3",
    tipo: "masculino",
    aliases: [
      "psg",
      "paris saint germain 2019",
      "paris",
      "saint germain",
      "2019 paris saint germain",
      "2019",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/psg/19-20-03/uni0.jpg",
      "/images/europa/psg/19-20-03/uni1.jpg",
      "/images/europa/psg/19-20-03/uni2.jpg",
      "/images/europa/psg/19-20-03/uni3.jpg",
      "/images/europa/psg/19-20-03/uni4.jpg",
    ],
  },
  {
    id: 21,
    pais: "europa",
    liga: "ligue-1",
    time: "paris-saint-germain",
    nome: "Paris Saint Germain 19/20 - Uniforme Edição Especial",
    tipo: "masculino",
    aliases: [
      "psg",
      "paris saint germain 2019",
      "paris",
      "saint germain",
      "2019 paris saint germain",
      "2019",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/psg/19-20-00-es/uni0.jpg",
      "/images/europa/psg/19-20-00-es/uni1.jpg",
      "/images/europa/psg/19-20-00-es/uni2.jpg",
      "/images/europa/psg/19-20-00-es/uni3.jpg",
      "/images/europa/psg/19-20-00-es/uni4.jpg",
    ],
  },
  {
    id: 22,
    pais: "europa",
    liga: "ligue-1",
    time: "paris-saint-germain",
    nome: "Paris Saint Germain 18/19 - Uniforme 2",
    tipo: "masculino",
    aliases: [
      "psg",
      "paris saint germain 2018",
      "paris",
      "saint germain",
      "2018 paris saint germain",
      "2018",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/psg/18-19-02/uni0.jpg",
      "/images/europa/psg/18-19-02/uni1.jpg",
    ],
  },
  {
    id: 23,
    pais: "europa",
    liga: "ligue-1",
    time: "paris-saint-germain",
    nome: "Paris Saint Germain 18/19 - Uniforme 3",
    tipo: "masculino",
    aliases: [
      "psg",
      "paris saint germain 2018",
      "paris",
      "saint germain",
      "2018 paris saint germain",
      "2018",
    ],
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/psg/18-19-03/uni0.jpg",
      "/images/europa/psg/18-19-03/uni1.jpg",
    ],
  },
  {
    id: 24,
    pais: "europa",
    liga: "ligue-1",
    time: "paris-saint-germain",
    nome: "Paris Saint Germain 12/13 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "psg",
      "paris saint germain 2012",
      "paris",
      "saint germain",
      "2012 paris saint germain",
      "2012",
      "paris saint germain retro",
      "retro paris saint germain",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/psg/12-13-01-rt/uni0.jpg",
      "/images/europa/psg/12-13-01-rt/uni1.jpg",
      "/images/europa/psg/12-13-01-rt/uni2.jpg",
      "/images/europa/psg/12-13-01-rt/uni3.jpg",
      "/images/europa/psg/12-13-01-rt/uni4.jpg",
    ],
  },
  {
    id: 25,
    pais: "europa",
    liga: "ligue-1",
    time: "paris-saint-germain",
    nome: "Paris Saint Germain 01/02 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "psg",
      "paris saint germain 2001",
      "paris",
      "saint germain",
      "2001 paris saint germain",
      "2001",
      "paris saint germain retro",
      "retro paris saint germain",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/psg/01-02-01-rt/uni0.jpg",
      "/images/europa/psg/01-02-01-rt/uni1.jpg",
      "/images/europa/psg/01-02-01-rt/uni2.jpg",
      "/images/europa/psg/01-02-01-rt/uni3.jpg",
      "/images/europa/psg/01-02-01-rt/uni4.jpg",
    ],
  },
  {
    id: 26,
    pais: "europa",
    liga: "ligue-1",
    time: "paris-saint-germain",
    nome: "Paris Saint Germain 01/02 - Uniforme 2 Retrô",
    tipo: "masculino",
    aliases: [
      "psg",
      "paris saint germain 2001",
      "paris",
      "saint germain",
      "2001 paris saint germain",
      "2001",
      "paris saint germain retro",
      "retro paris saint germain",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/psg/01-02-02-rt/uni0.jpg",
      "/images/europa/psg/01-02-02-rt/uni1.jpg",
      "/images/europa/psg/01-02-02-rt/uni2.jpg",
      "/images/europa/psg/01-02-02-rt/uni3.jpg",
      "/images/europa/psg/01-02-02-rt/uni4.jpg",
    ],
  },
  {
    id: 27,
    pais: "europa",
    liga: "ligue-1",
    time: "paris-saint-germain",
    nome: "Paris Saint Germain 95/96 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "psg",
      "paris saint germain 1995",
      "paris",
      "saint germain",
      "1995 paris saint germain",
      "1995",
      "paris saint germain retro",
      "retro paris saint germain",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/psg/95-96-01-rt/uni0.jpg",
      "/images/europa/psg/95-96-01-rt/uni1.jpg",
    ],
  },
  {
    id: 28,
    pais: "europa",
    liga: "ligue-1",
    time: "paris-saint-germain",
    nome: "Paris Saint Germain 90/91 - Uniforme 1 Retrô",
    tipo: "masculino",
    aliases: [
      "psg",
      "paris saint germain 1990",
      "paris",
      "saint germain",
      "1990 paris saint germain",
      "1990",
      "paris saint germain retro",
      "retro paris saint germain",
      "retro",
    ],
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/europa/psg/90-91-01-rt/uni0.jpg",
      "/images/europa/psg/90-91-01-rt/uni1.jpg",
      "/images/europa/psg/90-91-01-rt/uni2.jpg",
      "/images/europa/psg/90-91-01-rt/uni3.jpg",
      "/images/europa/psg/90-91-01-rt/uni4.jpg",
    ],
  },
  {
    id: 29,
    pais: "europa",
    liga: "ligue-1",
    time: "paris-saint-germain",
    nome: "Paris Saint Germain - Jaqueta (Preta)",
    tipo: "masculino",
    aliases: [
      "psg",
      "paris saint germain jaqueta",
      "paris",
      "saint germain",
      "jaqueta paris saint germain",
      "jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/psg/jp/uni0.jpg",
      "/images/europa/psg/jp/uni1.jpg",
      "/images/europa/psg/jp/uni2.jpg",
      "/images/europa/psg/jp/uni3.jpg",
      "/images/europa/psg/jp/uni4.jpg",
    ],
  },
  {
    id: 30,
    pais: "europa",
    liga: "ligue-1",
    time: "paris-saint-germain",
    nome: "Paris Saint Germain - Jaqueta (Preta)",
    tipo: "masculino",
    aliases: [
      "psg",
      "paris saint germain jaqueta",
      "paris",
      "saint germain",
      "jaqueta paris saint germain",
      "jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/psg/jp1/uni0.jpg",
      "/images/europa/psg/jp1/uni1.jpg",
      "/images/europa/psg/jp1/uni2.png",
      "/images/europa/psg/jp1/uni3.png",
      "/images/europa/psg/jp1/uni4.png",
    ],
  },
  {
    id: 31,
    pais: "europa",
    liga: "ligue-1",
    time: "paris-saint-germain",
    nome: "Paris Saint Germain - Jaqueta (Preta)",
    tipo: "masculino",
    aliases: [
      "psg",
      "paris saint germain jaqueta",
      "paris",
      "saint germain",
      "jaqueta paris saint germain",
      "jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/psg/jp2/uni0.jpg",
      "/images/europa/psg/jp2/uni1.jpg",
      "/images/europa/psg/jp2/uni2.jpg",
      "/images/europa/psg/jp2/uni3.jpg",
      "/images/europa/psg/jp2/uni4.jpg",
    ],
  },
  {
    id: 32,
    pais: "europa",
    liga: "ligue-1",
    time: "paris-saint-germain",
    nome: "Paris Saint Germain - Jaqueta (Preta)",
    tipo: "masculino",
    aliases: [
      "psg",
      "paris saint germain jaqueta",
      "paris",
      "saint germain",
      "jaqueta paris saint germain",
      "jaqueta",
    ],
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/europa/psg/jp3/uni0.jpg",
      "/images/europa/psg/jp3/uni1.jpg",
      "/images/europa/psg/jp3/uni2.jpg",
      "/images/europa/psg/jp3/uni3.jpg",
      "/images/europa/psg/jp3/uni4.jpg",
    ],
  },
];

export default psg;
